import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import PropertyCard from "../components/PropertyCard";
import { Heart } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function MyFavourites() {
  const { user, loading } = useAuth();
  const [items, setItems] = useState([]);
  const [busy, setBusy] = useState(true);

  useEffect(() => {
    if (!user) { setBusy(false); return; }
    axios.get(`${API}/my/favourites`)
      .then(({ data }) => setItems(data))
      .finally(() => setBusy(false));
  }, [user]);

  if (loading) return <div className="mx-auto max-w-4xl px-6 py-16 text-slate-500">Loading…</div>;

  if (!user) {
    return (
      <div className="mx-auto max-w-3xl px-6 py-16 text-center">
        <Heart className="mx-auto h-12 w-12 text-copper/40" />
        <h1 className="mt-4 font-display text-3xl font-bold">Sign in to see your favourites</h1>
        <p className="mt-2 text-slate-500">Save stays across Zambia and rebook your go-to lodges in one tap.</p>
        <Link to="/login" className="btn-primary mt-6 inline-block text-sm">Sign in</Link>
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-7xl px-6 py-10 lg:px-8">
      <div className="flex items-center gap-3">
        <Heart className="h-7 w-7 fill-copper text-copper" />
        <h1 className="font-display text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">Your favourites</h1>
      </div>
      <p className="mt-2 text-slate-600">Stays you&apos;ve hearted — grouped so you can compare and rebook in one tap.</p>

      <div className="mt-8">
        {busy ? (
          <div className="rounded-3xl bg-white p-10 text-center text-slate-500">Loading your saved stays…</div>
        ) : items.length === 0 ? (
          <div className="rounded-3xl bg-white p-10 text-center" data-testid="favourites-empty">
            <Heart className="mx-auto h-10 w-10 text-slate-300" />
            <p className="mt-3 text-slate-500">You haven&apos;t saved any stays yet. Tap the heart on any listing to add it here.</p>
            <Link to="/search" className="btn-primary mt-4 inline-block text-sm">Browse stays</Link>
          </div>
        ) : (
          <div className="grid grid-cols-1 gap-6 md:grid-cols-12" data-testid="favourites-grid">
            {items.map((p) => <PropertyCard key={p.id} property={p} />)}
          </div>
        )}
      </div>
    </div>
  );
}
